<template>
  <div class="pa-4">
    <v-file-input
        @click="onInputClick"
        :ref="id"
        :accept="accept"
        :id="id"
        chips
        small-chips
        truncate-length="15"
        class="d-none"
        @change="onChangeInputFile"
    ></v-file-input>
    <label :for="id" class="fs-1_3 cont-label-titulo-boton">
      <span class="white--text" :for="id"> <v-icon color="#FFFFFF">mdi-file-plus-outline</v-icon> {{ title }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "BtnInputFile",
  methods: {
    onInputClick: (event) => {
      event.target.value = ''
    },
    onChangeInputFile: async function () {
      this.parsedFile = await this.$papa.parse(event.target.files[0], this.config);
    },
    completeImportFile: async function (data, file) {
      this.onDataLoad(data, file);
    }
  },
  data() {
    return {
      config: {
        delimiter: "",	// auto-detect
        newline: "",	// auto-detect
        quoteChar: '"',
        escapeChar: '"',
        header: true,
        transformHeader: undefined,
        dynamicTyping: true,
        preview: 0,
        encoding: "ISO-8859-1",
        worker: false,
        comments: false,
        step: undefined,
        complete: this.completeImportFile,
        error: ()=>{
          this.$swal({
            timer: 3000,
            icon:`error`,
            title:`Importación con error'`,
            showConfirmButton: false
          });
        },
        download: false,
        downloadRequestHeaders: undefined,
        downloadRequestBody: undefined,
        skipEmptyLines: true,
        chunk: undefined,
        chunkSize: undefined,
        fastMode: undefined,
        beforeFirstChunk: undefined,
        withCredentials: undefined,
        transform: undefined,
        delimitersToGuess: [',', '\t', '|', ';']
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    accept: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    onDataLoad: {
      type: Function,
      default: () => {}
    }
  }

}
</script>

<style lang="scss" scoped>
.cont-label-titulo-boton{
  background: #02316C;
  border-radius: 8px;
  padding: 10px 20px;
  cursor: pointer;
}
</style>
